import { encodeBase64 } from "../../utils/utilityFunctions";
import { CALL_API } from "../middleware";
import { BANKS_LIST, BANKS_LIST_SUCCESS, BSE_RESEND_OTP, BSE_RESEND_OTP_SUCCESS, BSE_SUBMIT_GEN_OTP, BSE_SUBMIT_GEN_OTP_SUCCESS, INVESTOR_BANKS_LIST, INVESTOR_BANKS_LIST_SUCCESS } from "../types/bank";


export interface PortfolioList {
    portfolioId: string;
    portfolioName: string;
}
export interface InvestorList {
    clientCode: string;
    customerName: string;
    accountType: string;
    familyId: string;
    familyName: string;
    panNo: string;
    portfolioList: PortfolioList[];
    applicationId: number;
    applicantId: number;
    applicationType: string;
    investorType: string;
    status: string;
    onboardingType: string;
    isBSEEnabled:boolean;
}
export interface InvestorListBanksRes {
    result: InvestorList[];
    isSuccess: boolean;
    message: string;
}

export interface BanksListPayload {
    applicationId?: number|string;
    isBSEEnabled?:boolean;
    isActive?: boolean;
    searchInput?: string;
    currentPage?: number;
    rowsPerPage?: number;
}

export interface BankListObj {
    id: number;
    applicationId: string;
    swiftCode: any;
    ifscCode: string;
    micrCode: string;
    bankName: string;
    bankAccountNumber: string;
    bankAccountType: string;
    isActive: boolean;
    bankBranch: string;
    address1: string;
    address2: string;
    address3: string;
    currency: any;
    defaultBankAccount: boolean;
    pennydropCheck: boolean;
    pennydropVerified: boolean;
    createdBy: string;
    updatedBy: string;
    isModified: any;
    isDeleted: any;
    lastModifiedDate: any;
    chequeDocumentId: any;
    investorName: any;
    clientCode: any;
    createdAt: string;
    updatedAt: string;
    status?: string;
    documents?: any;
    mandateFlag?: boolean;
    bseStatus?: string;
    mpowerStatus?: string;
}

export interface BanksListRes {
    result: BankListObj[];
    isSuccess: boolean;
    message: string;
    count: number;
    isBSEEnabled: boolean;
    isMigrated?:boolean;
}

export interface bseGenOtpReq {
    banksList: BankListObj[];
    clientCode: string;
    isBSEEnabled: boolean;
    document: any;
    isMigrated?: boolean;
}

export interface bseGenOtpRes {
    isSuccess: boolean;
    id: number;
    token: string;
    maximum_attemps: string;
    failed_attempts: number;
    cartId: string;
    message: string;
    isBSEEnabled:boolean;
    numberOfOTPTries:number;
}

export interface submitBSEValidateOtpRes {
    isSuccess: boolean;
    message: string;
    id: number;
    cartId: string;
    login_token: null;
    role: null;
    userId: null;
    clientCode: string;
    banksList: any;
    isBseFailed?: boolean;
    isBSEEnabled:boolean;
}

export const investorListForBanks =
    (body: { rmId: string }) =>
        async (dispatch: any): Promise<InvestorListBanksRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/onboarding/investorListForBankModification',
                    method: 'POST',
                    types: [INVESTOR_BANKS_LIST_SUCCESS, INVESTOR_BANKS_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const fetchBanksList =
    (body: BanksListPayload) =>
        async (dispatch: any): Promise<BanksListRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/applications/banksList',
                    method: 'POST',
                    types: [BANKS_LIST_SUCCESS, BANKS_LIST],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const bseGenerateOtp =
    (body: bseGenOtpReq) =>
        async (dispatch: any): Promise<bseGenOtpRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/onboarding/generate-otp',
                    method: 'POST',
                    types: [BSE_SUBMIT_GEN_OTP_SUCCESS, BSE_SUBMIT_GEN_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const submitBSEValidateOtp =
    (body: {
        otp: string;
        cartId: string;
        portal?: string;
        id?: number | string;
        isBSEEnabled:boolean;
    }) =>
        async (dispatch: any): Promise<submitBSEValidateOtpRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/onboarding/validate-otp',
                    method: 'POST',
                    types: [BSE_SUBMIT_GEN_OTP_SUCCESS, BSE_SUBMIT_GEN_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const resendBSEValidateOtp =
    (body: {
        cartId: string;
        id?: number | string;
        isBSEEnabled:boolean;
    }) =>
        async (dispatch: any): Promise<bseGenOtpRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/onboarding/resend-otp',
                    method: 'POST',
                    types: [BSE_RESEND_OTP_SUCCESS, BSE_RESEND_OTP],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };